import type { GenericFormType } from './types'

// This can be used on any form and that's why we have any
// biome-ignore lint/suspicious/noExplicitAny: TODO - fix type definition
export const resetFieldMeta = (form: GenericFormType<any>, field: string) => {
  form.setFieldMeta(field, {
    errors: [],
    errorMap: {},
    isTouched: false,
    isPristine: true,
    isDirty: false,
    isValidating: false,
  })
}
